const CURRENCY_USD = 'USD';

const formatToCurrency = (
    value: number,
    options: Partial<Intl.NumberFormatOptions> = {},
) => {
    const {
        currency = CURRENCY_USD,
        minimumFractionDigits = 2,
        currencyDisplay = 'code',
        ...restOptions
    } = options;

    return Intl.NumberFormat('en-us', {
        minimumFractionDigits,
        currency,
        style: 'currency',
        currencyDisplay,
        ...restOptions,
    }).format(value);
};

const getSeparatorsByLocale = (
    locale: string,
): {
    thousands: string;
    decimal: string;
} => {
    const numberFormat = new Intl.NumberFormat(
        getLocaleForNumberFormat(locale),
    );

    return {
        thousands: numberFormat.format(1111).replace(/1/g, ''),
        decimal: numberFormat.format(1.1).replace(/1/g, ''),
    };
};

const getLocaleForNumberFormat = (locale: string) => {
    return locale === 'es' ? 'fr' : locale;
};

export const NumberHelper = {
    formatToCurrency,
    getSeparatorsByLocale,
};
